import addWindowScrollPositionToDocument from './modules/viewport';

// Custom modules
import CookieConsent from './modules/cookie-consent';
import initArrangementsSlider from './modules/arrangements-slider';
import initMobileMenuToggle from './modules/mobile-menu-toggle';
import initBookingForm from './modules/booking-form';
import initFormAlerts from './modules/form-alerts';
import initImageSlider from './modules/image-slider';

addWindowScrollPositionToDocument();

initArrangementsSlider();
initMobileMenuToggle();
initBookingForm();
initFormAlerts();
initImageSlider();

// Cookie consent
window.onload = () => {
    if (document.querySelector('[data-cmeleon-cookie-notice]') !== null || document.querySelector('[data-cmeleon-cookie-settings]') !== null) {
        const cookieConsent = new CookieConsent(document);
        if (document.querySelector('[data-cmeleon-cookie-notice]') !== null) {
            setTimeout(() => cookieConsent.showNotice(), 2000);
        }
    }
};
